import { formatDate } from "@cp/toolkit";
import type { InboxFullMessageFragment } from "@qw/graphql";
import type { FC } from "react";

import { DraftEditorReferenceMessageContent } from "./draft-editor-reference-message-content";
import { DraftMessageEmailLink } from "./draft-message-email-link";

export interface DraftEditorReferenceMessageReplyProps {
  message: InboxFullMessageFragment;
}

export const DraftEditorReferenceMessageReply: FC<DraftEditorReferenceMessageReplyProps> = ({ message }) => (
  <>
    <p>
      On {formatDate(new Date(message.date), "E, LLL d, yyyy 'at' h:mm a")}{" "}
      <DraftMessageEmailLink email={message.from} /> wrote:
    </p>

    <blockquote style={{ margin: "0px 0px 0px 0.8ex", borderLeft: "1px solid rgb(204, 204, 204)", paddingLeft: "1ex" }}>
      <DraftEditorReferenceMessageContent message={message} />
    </blockquote>
  </>
);
